import React from 'react';
import OtpInputForm from '../../common/otp_input_form';
import { Card, CardHeader, CardBody, Row } from 'reactstrap';

const PortalCustomPinForm = (props) => {
  const { user } = props;

  return (
    <Row>
      <Card className="bg-white mb-3 card-material">
        <CardHeader className="text-center">
          <h1 className="fs-5 fw-bold">{I18n.t('portal.custom_pins.edit.title')}</h1>
        </CardHeader>
        <CardBody className="text-center my-3">
          <p className="fw-bold mb-2">{I18n.t('portal.custom_pins.edit.new_pin')}</p>
          <div className="d-flex justify-content-center mb-3">
            <div className="input-pin d-flex align-items-center justify-content-start mb-2" style={{ width: '300px' }}>
              <OtpInputForm
                configuration={{
                  formName: 'profile',
                  attributeName: 'signature_pin'
                }}
                pinCode={user.signature_pin}
              />
            </div>
          </div>
          <p className="fw-bold mb-2">{I18n.t('portal.custom_pins.edit.confirm_new_pin')}</p>
          <div className="d-flex justify-content-center">
            <div className="input-pin d-flex align-items-center justify-content-start mb-2" style={{ width: '300px' }}>
              <OtpInputForm
                configuration={{
                  formName: 'profile',
                  attributeName: 'signature_pin_confirmation'
                }}
                pinCode={user.signature_pin_confirmation}
              />
            </div>
          </div>
        </CardBody>
      </Card>
    </Row>
  );
};

export default PortalCustomPinForm;
